import React from 'react';
import Combaintop from '../Components/Combaintop/Top';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
import About from '../Components/About/contact';
// import Banner from '../Components/banner/banner'
import Breadcrumbs from '../Components/banner/New-banner';

function Aboutpage() {
    return (
        <>
            <Combaintop />
            <Breadcrumbs />
            <About />
            <Combainbottom />
        </>
    );
}
export default Aboutpage;